import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Services',
      links: [
        { name: 'Buy Property', href: '#properties' },
        { name: 'Sell Property', href: '#contact' },
        { name: 'Property Valuation', href: '#contact' },
        { name: 'Investment Consulting', href: '#contact' }
      ]
    }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-luxhom" role="contentinfo">
      <div className="container">
        <div className="footer-content-luxhom">
          <div className="footer-section-luxhom">
            <div className="footer-logo-luxhom">
              <img 
                src="/images/truehomelogo-removebg-preview.png" 
                alt="TrueHome Properties - Leading real estate company across Karnataka, Goa, Andhra Pradesh, Tamil Nadu, Pune, and Mumbai" 
                loading="lazy"
              />
            </div>
            <p>
              Experience the pinnacle of luxury real estate with our exclusive collection 
              of premium properties. Your dream home awaits with personalized service 
              and unmatched expertise.
            </p>
            <nav className="footer-social-luxhom" aria-label="Social media links">
              <button className="social-link-luxhom" aria-label="Visit TrueHome Properties on Facebook" onClick={() => window.open('https://www.facebook.com/truehomeproperties', '_blank')}>
                <i className="fab fa-facebook-f" aria-hidden="true"></i>
              </button>
              <button className="social-link-luxhom" aria-label="Follow TrueHome Properties on Twitter" onClick={() => window.open('https://twitter.com/truehomeproperties', '_blank')}>
                <i className="fab fa-twitter" aria-hidden="true"></i>
              </button>
              <button className="social-link-luxhom" aria-label="Follow TrueHome Properties on Instagram" onClick={() => window.open('https://www.instagram.com/truehomeproperties', '_blank')}>
                <i className="fab fa-instagram" aria-hidden="true"></i>
              </button>
              <button className="social-link-luxhom" aria-label="Connect with TrueHome Properties on LinkedIn" onClick={() => window.open('https://www.linkedin.com/company/truehomeproperties', '_blank')}>
                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
              </button>
              <button className="social-link-luxhom" aria-label="Subscribe to TrueHome Properties on YouTube" onClick={() => window.open('https://www.youtube.com/truehomeproperties', '_blank')}>
                <i className="fab fa-youtube" aria-hidden="true"></i>
              </button>
            </nav>
          </div>

          {footerSections.map((section, index) => (
            <nav key={index} className="footer-section-luxhom" aria-label={`${section.title} navigation`}>
              <h4>{section.title}</h4>
              <ul>
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a 
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(link.href);
                      }}
                      aria-label={`Navigate to ${link.name}`}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <address className="footer-section-luxhom">
            <h4>Contact Info</h4>
            <p>
              <i className="fas fa-phone" aria-hidden="true"></i>
              <a href="tel:+919187458799" aria-label="Call TrueHome Properties at +91 9187458799">+91 9187458799</a>
            </p>
            <p>
              <i className="fas fa-phone" aria-hidden="true"></i>
              <a href="tel:+919187458798" aria-label="Call TrueHome Properties at +91 9187458798">+91 9187458798</a>
            </p>
            <p>
              <i className="fas fa-envelope" aria-hidden="true"></i>
              <a href="mailto:truehomeproperties.co.in@gmail.com" aria-label="Email TrueHome Properties">
                truehomeproperties.co.in@gmail.com
              </a>
            </p>
            <p>
              <i className="fas fa-globe" aria-hidden="true"></i>
              <a href="https://www.truehomeproperties.co.in" target="_blank" rel="noopener noreferrer" aria-label="Visit TrueHome Properties website">
                www.truehomeproperties.co.in
              </a>
            </p>
            <p>
              <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
              H.K Complex, Lakkenahalli Main Road<br />
              Jyothinagara, Madanayakanahalli<br />
              Bengaluru- 562123
            </p>
          </address>
        </div>

        <div className="footer-bottom-luxhom">
          <p>&copy; {currentYear} TrueHome Properties. All rights reserved. | Privacy Policy | Terms of Service</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;